module.exports = __webpack_public_path__ + "img/bg-prize.99f15857.png";